import { render, staticRenderFns } from "./ToDo.vue?vue&type=template&id=3752b6cd&lang=pug&"
import script from "./ToDo.vue?vue&type=script&lang=ts&"
export * from "./ToDo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ToDo.vue"
export default component.exports